import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import { NonMemberActivityService } from '../../Services/nonMemberActivity.service';
import Swal from 'sweetalert2';
import { UploadService } from '../../Services/upload.service';
import { saveAs } from 'file-saver';
import { Response } from '@angular/http';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';

@Component({
  selector: 'app-subscription-non-member-admin',
  template: require('./subscription-non-member-admin.component.html'),
  styles: [require('./subscription-non-member-admin.component.css')]
})
export class SubscriptionNonMemberAdminComponent implements OnInit {
  @ViewChild("fileInput") fileInput: ElementRef;

  loading: boolean = false;
  AllActivities: any = [];
  subscriptionYears: any=[]
  currentYear = new Date().getFullYear();

  newNonMemberActivity: any = {};
  allowRemarks: boolean=false;
  
  askTeam:boolean=false;
  askGsm:boolean=false;
  askBirthday:boolean=false;
  adultRequired:boolean=false;
  extraQuestion:boolean=false;

  askGender:boolean=false;
  askShortAddress:boolean=false;
  askAddress:boolean=false;
  askNationality:boolean=false;
  

  normalTarif:number = 0;
  selectedBeginDate: any;
  selectedEndDate: any;
  newTitle: string = '';
  newDescription: string ='';
  editId:number = 0;
  image:string='';
  extraQuestionText:string='';
  mailBodyHtml:string='';

  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor( private auth: AuthService,
    private nonMemberActivity: NonMemberActivityService,
    private uploadService: UploadService) { }

  ngOnInit() {   
    this.loadAllYearsOfSubscriptions()
    this.loadAllSubscriptionsForYear()
  }

  loadAllYearsOfSubscriptions(){
    this.nonMemberActivity.getAllYearsOfSubscriptions().subscribe ( res => {
      if (res.status == 200){
        this.subscriptionYears = res.value
      }
    })
  }

  yearSelected(){
    this.loadAllSubscriptionsForYear()    
  }

  deleteImage(){
    this.image = "";
  }

  loadAllSubscriptionsForYear(){
    this.loading = true;
    this.nonMemberActivity.getAllSubscriptionsByYear(this.currentYear).subscribe( res => {
      if (res.status == 200){
        this.AllActivities = res.value;
      }
      this.loading = false;
    })
  }

  switchClosed(id: number, open: boolean) {
    this.nonMemberActivity.changeClosed(id, open).subscribe(res => {
      if (res == 200) {
        var subs = this.AllActivities.find((e: any) => e.id == id)
        subs.open = open
      }
    })

  }

  newNonMemberActivityReset(){   
    this.selectedBeginDate = {};
    this.selectedEndDate = {};
    this.newTitle = '';
    this.newDescription ='';
    this.editId = 0;
    this.normalTarif = 0;
    this.image = "";
    this.allowRemarks = true;
    this.askTeam = false;
    this.askGsm = false;
    this.askBirthday = false;
    this.extraQuestion = false;
    this.askGender = false;
    this.askAddress = false;
    this.askShortAddress = false;
    this.askNationality = false;
    this.adultRequired = false;
    this.mailBodyHtml = "";
    this.extraQuestionText = "";
  }

  SaveNonMemberSubscription(){
    this.newNonMemberActivity.beginDate = String(this.selectedBeginDate.date.year)+"-"+String(this.selectedBeginDate.date.month)+"-"+String(this.selectedBeginDate.date.day)
    this.newNonMemberActivity.endDate = String(this.selectedEndDate.date.year)+"-"+String(this.selectedEndDate.date.month)+"-"+String(this.selectedEndDate.date.day)
    this.newNonMemberActivity.subject = this.newTitle;
    this.newNonMemberActivity.description = this.newDescription;
    this.newNonMemberActivity.open = false;
    this.newNonMemberActivity.normalTarif = this.normalTarif;
    this.newNonMemberActivity.allowRemarks = this.allowRemarks;
    this.newNonMemberActivity.askGsm = this.askGsm;
    this.newNonMemberActivity.askTeam= this.askTeam;
    this.newNonMemberActivity.askBirthday= this.askBirthday;
    this.newNonMemberActivity.adultRequired = this.adultRequired
 
    this.newNonMemberActivity.askGender = this.askGender;
    this.newNonMemberActivity.askAddress = this.askAddress;
    this.newNonMemberActivity.askShortAddress = this.askShortAddress;
    this.newNonMemberActivity.askNationality = this.askNationality;

    this.newNonMemberActivity.extraQuestion = this.extraQuestion;
    this.newNonMemberActivity.extraQuestionText = this.extraQuestionText;
    this.newNonMemberActivity.image = this.image
    this.newNonMemberActivity.mailBodyHtml = this.mailBodyHtml;
  
    if (this.editId > 0){
      this.newNonMemberActivity.id = this.editId;
      this.nonMemberActivity.updateActivity(this.newNonMemberActivity).subscribe( res => {
        this.loadAllSubscriptionsForYear();
        
      })
      
    }else{
      this.nonMemberActivity.createNewActivity(this.newNonMemberActivity).subscribe( res => {
        this.loadAllSubscriptionsForYear();
      });
    }
  }

  EditNonMemberActivity(subId:number){
    var s = this.AllActivities.find( (s:any) => s.id == subId)
    console.log(s)
    var bd = new Date(s.beginDate);
    this.selectedBeginDate = {
      jsdate: bd,
      date:{year: bd.getFullYear(), month: bd.getMonth() +1, day: bd.getDate()}
    };

    var ed = new Date(s.endDate);
    this.selectedEndDate = {
      jsdate: ed,
      date:{year: ed.getFullYear(), month: ed.getMonth() +1, day: ed.getDate()}
    };  
    
    
    this.newTitle = s.subject;
    this.newDescription = s.description;
    this.editId = s.id;  
    this.allowRemarks = s.allowRemarks;
    this.normalTarif = s.normalTarif;

    this.askGsm = s.askGsm;
    this.askTeam =s.askTeam;
    this.askBirthday = s.askBirthday;
    this.adultRequired = s.adultRequired;

    this.askGender = s.askGender;
    this.askAddress = s.askAddress;
    this.askShortAddress = s.askShortAddress;
    this.askNationality = s.askNationality;

    this.extraQuestion = s.extraQuestion;
    this.extraQuestionText = s.extraQuestionText;

    this.mailBodyHtml = s.mailBodyHtml;

    this.image = s.image
    
   
  }

  delete(id: number) {
    Swal.fire({
            title: 'Ben je zeker?',
            text: "Ben je zeker dat je deze activiteit wil verwijderen?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Jep',
            cancelButtonText: 'Nope'
          }).then((result) => {
            if (result.value) {
              this.nonMemberActivity.delete(id).subscribe(x => {
                this.loadAllSubscriptionsForYear();
              })
            }
          });
  }

  uploadPhoto() {
    var nativeElement: HTMLInputElement = this.fileInput.nativeElement;
    if (nativeElement != null) {
      var files = nativeElement.files;
      if (files != null) {
        var file = files[0];
        console.log(file);
        
        this.uploadService.uploadNonMemberActivityPoster(file).subscribe( (res:any) => {
          console.log(res);
          
           if (res.status == 200){
            this.image = res.value.filename
           }
        })
      }
    }
  }

  CopyLinkToClipboard(id:number){
    var cpLink = window.location.origin;

    cpLink += '/subscription/nonmembers/'+id

    console.log(cpLink);
    
  
    let anyNavigator: any;
    anyNavigator = window.navigator;
    anyNavigator.clipboard.writeText(cpLink);
    Swal.fire({
      text: "Link gekopieerd naar het clipboard",
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Ok',
    })
  }
  
  DownloadNonMemberSubscription(id: number){
    this.nonMemberActivity.downloadExcel(id).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/subscription-non-member-admin/subscription-non-member-admin.component.ts